// P24 — i18n simple FR/EN (sans lib externe)
// Helper `t(key)` qui retourne la traduction depuis locales/{fr,en}.json
// Pour MVP : couvre les ~50 chaînes les plus visibles (sidebar, dashboard, login)
// Pas une couverture 100% (ça serait l'objet d'un sprint dédié).
import fr from "@/locales/fr.json";
import en from "@/locales/en.json";

export type Locale = "fr" | "en";
const LOCALES: Record<Locale, Record<string, string>> = { fr, en };

// Lit la locale depuis localStorage (défaut : fr)
let currentLocale: Locale = (localStorage.getItem("locale") as Locale) || "fr";

export function getLocale(): Locale {
  return currentLocale;
}

export function setLocale(loc: Locale): void {
  currentLocale = loc;
  localStorage.setItem("locale", loc);
  // Force re-render via custom event
  window.dispatchEvent(new CustomEvent("localechange", { detail: loc }));
}

// Subscribe to locale changes
if (typeof window !== "undefined") {
  window.addEventListener("localechange", (e) => {
    currentLocale = (e as CustomEvent<Locale>).detail;
  });
}

/** Translate a key. Returns the key itself if not found. */
export function t(key: string): string {
  return LOCALES[currentLocale][key] ?? LOCALES.fr[key] ?? key;
}

/** React hook to re-render on locale change. */
import { useEffect, useState } from "react";
export function useT(): (key: string) => string {
  const [, setTick] = useState(0);
  useEffect(() => {
    const handler = () => setTick((n) => n + 1);
    window.addEventListener("localechange", handler);
    return () => window.removeEventListener("localechange", handler);
  }, []);
  return t;
}
